import { useTranslation } from '@thoughtspot/i18n';
import _ from 'lodash';
import React, { useCallback, useEffect, useMemo } from 'react';
import { IntegrationActionEnum } from "../../../../services/generated/graphql-types";
import { useGetVendorsListQuery, useSetIntegrationMutation, } from "../../../../services/spotiq/spotiq-service";
import { DeleteConfirmationModal } from '../delete-confirmation-modal/delete-confirmation-modal';
import { transformToIntegrationData, transformToIntegrationInput, TranslationsKeys, VendorEnumToString, } from '../util';
import AddEditIntegration from './add-edit-integration';
export const IntegrationActionModalContainer = ({ actionModalType, setIsActionModalOpen, isActionModalOpen, currRow, setCurrRowId, setSuccessToast, integrationsListRefetch, setFailureMessage, }) => {
    const { t } = useTranslation();
    const { data: vendorsListData, loading: vendorsListLoading, error: vendorsListError, refetch: vendorsListRefetch, } = useGetVendorsListQuery();
    const { error: setIntegrationError, loading: setIntegrationLoading, setIntegration, } = useSetIntegrationMutation();
    const closeFn = useCallback(() => {
        setIsActionModalOpen(false);
        setCurrRowId(null);
    }, []);
    const integrationInfo = transformToIntegrationData(currRow);
    const onSave = useCallback((row) => {
        const input = transformToIntegrationInput(row, actionModalType);
        setIntegration(input)
            .then(() => {
            integrationsListRefetch();
            let successMessage;
            switch (actionModalType) {
                case IntegrationActionEnum.Edit:
                    successMessage = t(TranslationsKeys.SUCCESS_MSG_EDIT_INTEGRATION);
                    break;
                case IntegrationActionEnum.Create:
                    successMessage = t(TranslationsKeys.SUCCESS_MSG_ADD_INTEGRATION);
                    break;
                case IntegrationActionEnum.Delete:
                    successMessage = t(TranslationsKeys.SUCCESS_MSG_DELETE_INTEGRATION);
                    break;
                default:
                    break;
            }
            setSuccessToast(successMessage);
            return closeFn();
        })
            .catch(() => {
            if (actionModalType === IntegrationActionEnum.Delete) {
                setFailureMessage(t(TranslationsKeys.FAILED_MSG_DELETE_INTEGRATION));
                closeFn();
            }
        });
    }, [actionModalType]);
    const onDeleteConfirm = useCallback(() => {
        onSave(integrationInfo);
    }, [onSave, integrationInfo]);
    const vendors = useMemo(() => {
        let vendors1 = [];
        if (!_.isEmpty(vendorsListData) && !_.isEmpty(vendorsListData.Data)) {
            vendors1 = [
                {
                    options: vendorsListData.Data.map(vendor => ({
                        id: vendor.toString(),
                        label: VendorEnumToString[vendor] || vendor,
                    })),
                },
            ];
        }
        else {
            vendors1 = [
                {
                    options: currRow
                        ? [
                            {
                                id: currRow.vendor.text,
                                label: currRow.vendorName.text,
                            },
                        ]
                        : [],
                },
            ];
        }
        return vendors1;
    }, [vendorsListData]);
    useEffect(() => {
        if (isActionModalOpen &&
            actionModalType === IntegrationActionEnum.Create) {
            vendorsListRefetch();
        }
    }, [isActionModalOpen]);
    return (React.createElement(React.Fragment, null,
        actionModalType !== IntegrationActionEnum.Delete && (React.createElement(AddEditIntegration, { onSave: onSave, onCancel: closeFn, vendorsList: vendors, isModalOpen: isActionModalOpen, currRow: currRow, vendorsListLoading: vendorsListLoading, setIntegrationLoading: setIntegrationLoading, setIntegrationError: setIntegrationError, vendorsListError: vendorsListError })),
        actionModalType === IntegrationActionEnum.Delete && (React.createElement(DeleteConfirmationModal, { isModalOpen: isActionModalOpen, onDeleteConfirm: onDeleteConfirm, onDeleteModalClose: closeFn, showLoader: setIntegrationLoading, currRow: currRow }))));
};
//# sourceMappingURL=integration-action-modal.container.js.map